/*
 * StatusLegend — collapsible glossary of trip lifecycle states.
 * Placed next to the TP Trips page title so new dispatchers can decode pills.
 */
import React, { useState } from "react";
import { HelpCircle, X } from "lucide-react";

const STATUSES = [
  ["ACCEPTED", "bg-slate-100 text-slate-700", "Trip created but not yet routed to a TP."],
  ["OFFERED_TP", "bg-blue-100 text-blue-800", "Offered to a TP — waiting for dispatcher to accept."],
  ["ASSIGNED", "bg-amber-100 text-amber-800", "Driver assigned. SMS sent (or scheduled). Awaiting driver Accept."],
  ["EN_ROUTE", "bg-forest text-white", "Driver accepted. Heading to pickup."],
  ["ARRIVED_PU", "bg-violet-600 text-white", "Driver arrived at the pickup location."],
  ["ON_TRIP", "bg-blue-600 text-white", "Rider on-board. En route to drop-off."],
  ["ARRIVED_DO", "bg-violet-700 text-white", "Arrived at the drop-off. Awaiting signature."],
  ["COMPLETED", "bg-green-600 text-white", "Signature captured. POD exploded to broker + OVA + billing."],
  ["NO_SHOW_CONFIRMED", "bg-red-600 text-white", "Rider did not show. Photo evidence captured."],
  ["REASSIGN_NEEDED", "bg-red-100 text-red-800", "Driver dropped or was un-assigned. Needs a new driver."],
  ["CANCELLED", "bg-slate-300 text-slate-800", "Trip cancelled before completion."],
];

export default function StatusLegend() {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1 text-xs text-slate-600 hover:text-forest border border-[#E2E0D8] px-2 py-1 rounded-md"
        data-testid="status-legend-toggle"
      >
        <HelpCircle size={13} /> Status glossary
      </button>
      {open && (
        <div
          className="absolute right-0 mt-2 w-[380px] bg-white border border-[#E9EAE4] rounded-xl shadow-lg p-4 z-[10000]"
          data-testid="status-legend-popover"
        >
          <div className="flex justify-between items-center mb-3">
            <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Trip lifecycle</div>
            <button onClick={() => setOpen(false)} className="text-slate-400 hover:text-slate-700">
              <X size={14} />
            </button>
          </div>
          <div className="space-y-2 max-h-[360px] overflow-y-auto">
            {STATUSES.map(([status, cls, desc]) => (
              <div key={status} className="flex items-start gap-2">
                <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold shrink-0 ${cls}`}>
                  {status}
                </span>
                <span className="text-xs text-slate-600 pt-0.5">{desc}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
